import React from 'react';
import { REAL_ESTATE_COLUMN_WIDTH, V2_TABLE_COLUMN_COUNT } from './constants';

// Единая раскладка колонок для родительской и вложенной (помесячной) таблиц рейтинга v2.
// Колонка «ЖК» фиксированной ширины, остальные делят остаток поровну (tableLayout: fixed).
const PartnerRatingColGroup = () => (
  <colgroup>
    <col style={{ width: REAL_ESTATE_COLUMN_WIDTH }} />
    {Array.from({ length: V2_TABLE_COLUMN_COUNT - 1 }).map((_, index) => (
      <col key={index} />
    ))}
  </colgroup>
);

export default PartnerRatingColGroup;
